export default __webpack_public_path__ + "static/media/backdrop.81605517.jpg";